import { z } from 'zod';

export const ApiCountrySchema = z.object({
  _id: z.string(),
  englishShortName: z.string(),
  alpha2Code: z.string(),
  alpha3Code: z.string(),
  numeric: z.number(),
  regions: z.record(z.string(), z.string()),
});

export type ApiCountry = z.infer<typeof ApiCountrySchema>;
